import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import {
  CreateOrgUserRequest,
  CreateOrgUserResponse,
  DisableOrgUserResponse,
  EnableOrgUserResponse,
  OrgUserListItem,
  ResetOrgUserPasswordRequest,
  ResetOrgUserPasswordResponse,
  UpdateOrgUserRequest,
} from './org-user.model';

@Injectable({
  providedIn: 'root',
})
export class OrgUserService {
  #http = inject(HttpClient);

  private get baseUrl(): string {
    return `${environment.urls.standaloneApi}/v1/org/users`;
  }

  listUsers(): Observable<OrgUserListItem[]> {
    return this.#http.get<OrgUserListItem[]>(this.baseUrl);
  }

  createUser(request: CreateOrgUserRequest): Observable<CreateOrgUserResponse> {
    return this.#http.post<CreateOrgUserResponse>(this.baseUrl, request);
  }

  disableUser(userId: string): Observable<DisableOrgUserResponse> {
    return this.#http.put<DisableOrgUserResponse>(
      `${this.baseUrl}/${encodeURIComponent(userId)}/disable`,
      {},
    );
  }

  enableUser(userId: string): Observable<EnableOrgUserResponse> {
    return this.#http.put<EnableOrgUserResponse>(
      `${this.baseUrl}/${encodeURIComponent(userId)}/enable`,
      {},
    );
  }

  resetPassword(
    userId: string,
    request: ResetOrgUserPasswordRequest,
  ): Observable<ResetOrgUserPasswordResponse> {
    return this.#http.put<ResetOrgUserPasswordResponse>(
      `${this.baseUrl}/${encodeURIComponent(userId)}/reset-password`,
      request,
    );
  }

  /** Requires backend B0 (`PUT /api/v1/org/users/{userId}`). */
  updateUser(userId: string, request: UpdateOrgUserRequest): Observable<void> {
    return this.#http.put<void>(`${this.baseUrl}/${encodeURIComponent(userId)}`, request);
  }
}
